<template>
    
</template>

<script>

    import PreviewElement from "./PreviewElement";
    import FramedImageElement from "../../components/pagesbuilder/elements/FramedImageElement";
    export default {
        name: "PreviewFramedImageElement",
        mixins: [PreviewElement,FramedImageElement]
    }
</script>
